/**
 * Card Async Reducer
 */

import { Actions } from "containers/CardAsync/store/Actions";
import { Reducer } from "redux";
import { getCardAsyncFormTranslations } from "root/shared/MultiLanguage";
import { IInputProps } from "root/store/CajitaStore";
import { ICardAsyncActionCreator } from "types/card_async_action_creator";
import { ICardAsyncFormProps } from "types/card_async_form_props";

const initialState: ICardAsyncFormProps = {
  is_subscription: false,
  isCardAsyncAvailable: true,
  isValid: false,
  totalAmount: 0,
  token: "",
  emailInput: {
    container: "card_async",
    value: "",
    classContainer: "inputContainer email-input",
    valid: true,
    dirty: false,
    classes: ["input"],
    inputPattern: /^[a-zA-Z0-9._+-@]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      isEmail: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "emailInput",
      type: "text",
    },
  },
  currency: "CLP",
  translation: getCardAsyncFormTranslations(),
};

const CardAsyncReducer: Reducer<ICardAsyncFormProps> = (
  state: ICardAsyncFormProps = initialState,
  action: ICardAsyncActionCreator
): ICardAsyncFormProps => {
  let input: IInputProps;

  switch (action.type) {
    case Actions.UPDATE_CARD_ASYNC_INPUT:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: input,
      };
    case Actions.SET_CARD_ASYNC_INPUT_DIRTY:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: {
          ...state[input.attributes.id],
          dirty: true,
        },
      };
    case Actions.SWITCH_CARD_ASYNC_VALIDITY:
      return {
        ...state,
        isValid: !state.isValid,
      };
    case Actions.SET_CARD_ASYNC_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    case Actions.DISABLE_CARD_ASYNC_FORM:
      return {
        ...state,
        isCardAsyncAvailable: false,
      };
    case Actions.ENABLE_CARD_ASYNC_FORM:
      return {
        ...state,
        isCashAvailable: true,
      };
    default:
      return state;
  }
};

export { CardAsyncReducer };



// WEBPACK FOOTER //
// ./src/containers/CardAsync/store/Reducer.tsx